import ApiService from "@/services/api.service";
import { MediaAsset, tImage, tVideo, Image, Video } from "@/models/media-asset";
import { ISettings } from "@/models/common";
import QS from "qs";
import { ArrayQuery } from "@/services/query-builder";

const api = new ApiService();

class UserMediaAssetAdminApi {
  public async all(userId: number, query: { arrayQuery?: ArrayQuery }): Promise<MediaAsset> {
    const queryString = QS.stringify(query);

    return await api.get(`/admin/users/${userId}/media-asset/all?${queryString}`);
  }

  public async uploadImage(
    userId: number,
    params: FormData,
    settings: ISettings = { resultKeyOnSuccess: "data", tModel: tImage }
  ): Promise<Image> {
    return await api.post(`/admin/users/${userId}/media-asset/upload/image`, params, settings);
  }

  public async uploadVideo(
    userId: number,
    params: FormData,
    settings: ISettings = { resultKeyOnSuccess: "data", tModel: tVideo }
  ): Promise<Video> {
    return await api.post(`/admin/users/${userId}/media-asset/upload/video`, params, settings);
  }
}

export default new UserMediaAssetAdminApi();
